import { Card, Typography } from 'antd';
import styled from 'styled-components';

const { Title, Paragraph } = Typography;

export const StyledCard = styled(Card)`
  box-shadow: 0px 0px 15px 0px #e7eaf6;
  border: 1px solid #f4f4f4;
`;

export const DetailsBody = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media only screen and (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ItemTitle = styled(Title).attrs({ level: 5 })`
  &&& {
    font-size: 14px;
    margin-bottom: 0;
  }
`;

export const ItemValue = styled(Paragraph)`
  &&& {
    font-size: 14px;
    margin-bottom: 0;
  }
`;

export const StyledIcon = styled.div`
  padding: 8px;
  background-color: #eef4ff;
  border-radius: 8px;
  height: 44px;
`;

export const HealthItem = styled.div`
  border: 1px solid var(--text-10);
  padding: 12px 16px;
  display: flex;
  gap: 16px;
  border-radius: 10px;
`;
